import { jsx as _jsx } from "react/jsx-runtime";
import { Fade, Grid } from "@mui/material";
import { postsStore } from "../../../../stores/posts/postsStore";
import { GalleryCard } from "./GalleryCard";
import { Loader } from "../../../loaders/Loader";
export const GalleryList = () => {
    const pageItems = postsStore.usePageItems();
    const request = postsStore.useRequestStatus();
    return (_jsx(Grid, { container: true, spacing: 1, justifyContent: 'center', children: _jsx(Loader, { status: request, data: pageItems, children: pageItems.map((i, index) => _jsx(Fade, { in: true, timeout: 500 + index * 500, children: _jsx(Grid, { item: true, children: _jsx(GalleryCard, { post: i }, void 0) }, void 0) }, i.id)) }, void 0) }, void 0));
};
//# sourceMappingURL=GalleryList.js.map